import i18n from "i18next";
import {
  BOOKABLE_SPACE_OPTIONS,
  MEETING_TYPE_OTHER,
  SPACE_ID_FLEX_WORKSPACE,
  SPACE_ID_KITCHEN,
  SPACE_ID_MAAK,
  SPACE_ID_MEETING_ROOM,
  SPACE_ID_RADIO,
  SPACE_ID_STUDIO,
} from "../constants/SpacesConstants";
import {
  HIRE_REQUEST_STATUS_ACCEPTED,
  HIRE_REQUEST_STATUS_COMPLETED,
  HIRE_REQUEST_STATUS_DETAILS_SUBMITTED,
  HIRE_REQUEST_STATUS_OPEN,
  HIRE_REQUEST_STATUS_REJECTED,
  HIRE_REQUEST_STATUS_SIGNED,
} from "../constants/HireRequestConstants";

export const formatSpace = (space) => {
  switch (space) {
    case SPACE_ID_STUDIO:
      return i18n.t("studio_space");
    case SPACE_ID_FLEX_WORKSPACE:
      return i18n.t("flex_space");
    case SPACE_ID_MEETING_ROOM:
      return i18n.t("meeting_room");
    case SPACE_ID_MAAK:
      return i18n.t("maak_room");
    case SPACE_ID_KITCHEN:
      return i18n.t("booking.space_kitchen");
    case SPACE_ID_RADIO:
      return i18n.t("booking.space_radio");
    default:
      // Liever de ruwe waarde dan een verkeerde ruimte tonen.
      return space || "-";
  }
};

// De ruimtes die in één aanvraag gecombineerd konden worden.
export const formatBookableSpaces = (spaceIds) => {
  if (!spaceIds?.length) return null;
  return spaceIds
    .map((id) => {
      const option = BOOKABLE_SPACE_OPTIONS.find((item) => item.value === id);
      return option ? i18n.t(option.labelKey) : id;
    })
    .join(", ");
};

export const formatExtras = (extras) => {
  if (!extras?.length) return null;
  return extras.map((extra) => i18n.t(`extras.${extra}`)).join(", ");
};

export const formatMeetingType = (meetingType, meetingTypeOther) => {
  if (!meetingType) return null;
  if (meetingType === MEETING_TYPE_OTHER)
    return meetingTypeOther || i18n.t(`meeting_type.${MEETING_TYPE_OTHER}`);
  return i18n.t(`meeting_type.${meetingType}`);
};

export const formatRequestStatus = (status) => {
  switch (status) {
    case HIRE_REQUEST_STATUS_OPEN:
      return i18n.t("open");
    case HIRE_REQUEST_STATUS_ACCEPTED:
      return i18n.t("accepted");
    case HIRE_REQUEST_STATUS_DETAILS_SUBMITTED:
      return i18n.t("details_submitted");
    case HIRE_REQUEST_STATUS_SIGNED:
      return i18n.t("signed");
    case HIRE_REQUEST_STATUS_COMPLETED:
      return i18n.t("completed");
    case HIRE_REQUEST_STATUS_REJECTED:
      return i18n.t("rejected");
    default:
      return i18n.t("open");
  }
};

export const getRequestStatusColor = (status) => {
  switch (status) {
    case HIRE_REQUEST_STATUS_OPEN:
      return "orange";
    case HIRE_REQUEST_STATUS_ACCEPTED:
      return "blue";
    case HIRE_REQUEST_STATUS_SIGNED:
      return "lime";
    case HIRE_REQUEST_STATUS_COMPLETED:
      return "green";
    case HIRE_REQUEST_STATUS_REJECTED:
      return "red";
    default:
      return "orange";
  }
};
